import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { QuickPayRoute } from "./quickPay.routes";

type Props = {};

export function SchedulingModule({}: Props): React.ReactElement {
  return (
    <Layout>
      {QuickPayRoute.subRoutes && (
        <ModuleRouter subRoutes={QuickPayRoute.subRoutes} path={QuickPayRoute.path} />
      )}
    </Layout>
  );
}
